export default __webpack_public_path__ + "static/media/No.7-0.f82a6783.jpg";